import React from "react"
import { createRoot } from "react-dom/client"
import { Badge, Btn, Icon } from "./groupssuite/ui"

function FieldDisplay({ label, value, children }) {
  return (
    <div className="field-display">
      <div className="field-display__label">{label}</div>
      <div className="field-display__value">{children || value || "–"}</div>
    </div>
  )
}

function DomainShow({ domain, channels, labels, canEdit, editPath, backPath }) {
  return (
    <section className="screen">
      <header className="screen__head">
        <div>
          <a href={backPath} className="screen__back">
            <Icon name="arrow_left" size={14} /> {labels.back}
          </a>
          <h1 className="screen__title">{domain.name}</h1>
          <p className="screen__subtitle">{domain.host}</p>
        </div>
        {canEdit && <Btn variant="accent" icon="edit" href={editPath}>{labels.edit}</Btn>}
      </header>

      <div className="detail-grid">
        <FieldDisplay label={labels.fields.languages}>
          <div className="badge-row">
            {domain.languages.map((l) => <Badge key={l}>{l.toUpperCase()}</Badge>)}
          </div>
        </FieldDisplay>
        <FieldDisplay label={labels.fields.default_goal} value={domain.default_goal} />
        <FieldDisplay label={labels.fields.brand_voice} value={domain.brand_voice} />
        <FieldDisplay label={labels.fields.target_audience} value={domain.target_audience} />
      </div>

      <h2 className="section-title">{labels.channels.title}</h2>
      <div className="channel-list">
        {channels.map((c) => (
          <div key={c.id} className="channel-row">
            <div className="channel-row__platform">{labels.platforms[c.platform]}</div>
            <Badge tone={c.status === "connected" ? "success" : "neutral"} dot>
              {labels.statuses[c.status]}
            </Badge>
            <div className="channel-row__account">{c.external_account_id || "–"}</div>
            <Btn variant="secondary" icon="link" disabled title={labels.channels.connect_hint}>
              {labels.channels.connect}
            </Btn>
          </div>
        ))}
      </div>
    </section>
  )
}

function mount() {
  const el = document.getElementById("domain-show")
  if (!el || el.dataset.mounted === "true") return
  let props = {}
  try {
    props = JSON.parse(el.dataset.props || "{}")
  } catch (error) {
    console.error("Invalid domain-show props", error)
  }
  el.dataset.mounted = "true"
  createRoot(el).render(<DomainShow {...props} />)
}

document.addEventListener("turbo:load", mount)
document.addEventListener("DOMContentLoaded", mount)
